import { throttle } from "lodash"

export const getPosition = throttle(_getPosition, 100)
function _getPosition({ target, clientX, clientY }, direction) {
    const position = [clientX - getLeftOffset(target), clientY - getTopOffset(target)]

    const targetPositions = [target.offsetWidth, target.offsetHeight]
    // console.log({
    //     position,
    //     targetPositions,
    //     offsetLeft: getLeftOffset(target),
    //     offsetTop: getTopOffset(target),
    //     clientX,
    //     clientY,
    // })

    const left = position[0] / targetPositions[0] * 100
    const top = position[1] / targetPositions[1] * 100

    if (direction === "column") {
        if (left < 50) return "left"
        else if (left >= 50) return "right"
    } else {
        if (top < 50) return "top"
        else if (top >= 50) return "bottom"
    }
    return "none"
}

function getLeftOffset(element) {
    let result = 0
    while (element) {
        result += element.offsetLeft + element.scrollLeft
        element = element.offsetParent
    }

    return result - window.scrollX
}

function getTopOffset(element) {
    let result = 0
    while (element) {
        result += element.offsetTop + element.scrollTop
        element = element.offsetParent
    }

    return result - window.scrollY
}



// WEBPACK FOOTER //
// ./src/features/editor/dnd/utils.js